import _defineProperty from "/codebuild/output/src4038/src/s3/01/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/codebuild/output/src4038/src/s3/01/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _asyncToGenerator from "/codebuild/output/src4038/src/s3/01/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/codebuild/output/src4038/src/s3/01/node_modules/@babel/runtime/regenerator/index.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { GrowthBook } from '@growthbook/growthbook';
export { BrowserCookieStickyBucketService, ExpressCookieStickyBucketService, GrowthBook, LocalStorageStickyBucketService, RedisStickyBucketService, StickyBucketService, clearCache, configureCache, getPolyfills, helpers, prefetchPayload, setPolyfills } from '@growthbook/growthbook';
import * as React from 'react';
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
var GrowthBookContext = /*#__PURE__*/React.createContext({});

/** @deprecated */
function getGrowthBookSSRData(_x) {
  return _getGrowthBookSSRData.apply(this, arguments);
}
/** @deprecated */
function _getGrowthBookSSRData() {
  _getGrowthBookSSRData = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(context) {
    var gb, data;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          // Server-side GrowthBook instance
          gb = new GrowthBook(_objectSpread({}, context)); // Load feature flags from network if needed
          if (!context.clientKey) {
            _context.next = 4;
            break;
          }
          _context.next = 4;
          return gb.loadFeatures();
        case 4:
          data = {
            attributes: gb.getAttributes(),
            features: gb.getFeatures()
          };
          gb.destroy();
          return _context.abrupt("return", data);
        case 7:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _getGrowthBookSSRData.apply(this, arguments);
}
function useGrowthBookSSR(data) {
  var gb = useGrowthBook();

  // Only do this once to avoid infinite loops
  var isFirst = React.useRef(true);
  if (gb && isFirst.current) {
    gb.setFeatures(data.features);
    gb.setAttributes(data.attributes);
    isFirst.current = false;
  }
}
function useExperiment(exp) {
  var _React$useContext = React.useContext(GrowthBookContext),
    growthbook = _React$useContext.growthbook;
  return growthbook.run(exp);
}
function useFeature(id) {
  var growthbook = useGrowthBook();
  return growthbook.evalFeature(id);
}
function useFeatureIsOn(id) {
  var growthbook = useGrowthBook();
  return growthbook.isOn(id);
}
function useFeatureValue(id, fallback) {
  var growthbook = useGrowthBook();
  return growthbook.getFeatureValue(id, fallback);
}
function useGrowthBook() {
  var _React$useContext2 = React.useContext(GrowthBookContext),
    growthbook = _React$useContext2.growthbook;
  if (!growthbook) {
    throw new Error("Missing or invalid GrowthBookProvider");
  }
  return growthbook;
}
function FeaturesReady(_ref) {
  var children = _ref.children,
    timeout = _ref.timeout,
    fallback = _ref.fallback;
  var gb = useGrowthBook();
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    hitTimeout = _React$useState2[0],
    setHitTimeout = _React$useState2[1];
  var ready = gb ? gb.ready : false;
  React.useEffect(function () {
    if (timeout && !ready) {
      var timer = setTimeout(function () {
        gb && gb.log("FeaturesReady timed out waiting for features to load", {
          timeout: timeout
        });
        setHitTimeout(true);
      }, timeout);
      return function () {
        return clearTimeout(timer);
      };
    }
  }, [timeout, ready, gb]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, ready || hitTimeout ? children : fallback || null);
}
function IfFeatureEnabled(_ref2) {
  var children = _ref2.children,
    feature = _ref2.feature;
  return useFeature(feature).on ? /*#__PURE__*/React.createElement(React.Fragment, null, children) : null;
}
function FeatureString(props) {
  var value = useFeature(props.feature).value;
  if (value !== null) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, value);
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, props["default"]);
}
var withRunExperiment = function withRunExperiment(Component) {
  // eslint-disable-next-line
  var withRunExperimentWrapper = function withRunExperimentWrapper(props) {
    return /*#__PURE__*/React.createElement(GrowthBookContext.Consumer, null, function (_ref3) {
      var growthbook = _ref3.growthbook;
      return /*#__PURE__*/React.createElement(Component, _extends({}, props, {
        runExperiment: function runExperiment(exp) {
          return growthbook.run(exp);
        }
      }));
    });
  };
  return withRunExperimentWrapper;
};
withRunExperiment.displayName = "WithRunExperiment";
var GrowthBookProvider = function GrowthBookProvider(_ref4) {
  var children = _ref4.children,
    growthbook = _ref4.growthbook;
  // Tell growthbook how to re-render our app (for dev mode integration)
  // eslint-disable-next-line
  var _React$useState3 = React.useState(0),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    _ = _React$useState4[0],
    setRenderCount = _React$useState4[1];
  React.useEffect(function () {
    if (!growthbook || !growthbook.setRenderer) return;
    growthbook.setRenderer(function () {
      setRenderCount(function (v) {
        return v + 1;
      });
    });
    return function () {
      growthbook.setRenderer(function () {
        // do nothing
      });
    };
  }, [growthbook]);
  return /*#__PURE__*/React.createElement(GrowthBookContext.Provider, {
    value: {
      growthbook: growthbook
    }
  }, children);
};
export { FeatureString, FeaturesReady, GrowthBookContext, GrowthBookProvider, IfFeatureEnabled, getGrowthBookSSRData, useExperiment, useFeature, useFeatureIsOn, useFeatureValue, useGrowthBook, useGrowthBookSSR, withRunExperiment };